import React, { useContext } from 'react'
import { UserContext } from '../../../App'
import { LoadingFull } from '../../loading'

const ChatsSingle = ({chat, selected, setSelected, setChatsOpen}) => {
    const { user } = useContext(UserContext)
    return (
        <div className={"w-full cursor-pointer flex gap-5 items-center p-5 relative rounded-xl " + (typeof selected !== 'undefined' ? selected.chatId !== chat.chatId ? " hover:bg-neutral-100" : " lg:bg-neutral-100 hover:bg-neutral-100" : " hover:bg-neutral-100")} onClick={() => setSelected(chat) & setChatsOpen(false)}>
            <div className="image w-20 h-20 aspect-square bg-neutral-100">
                <img src={`https://firebasestorage.googleapis.com/v0/b/bolig2.appspot.com/o/${chat.dbId}%2F0?alt=media`} alt='BOOK' className="m-auto h-full object-contain bg-neutral-100" />
            </div>
            <div className="flex flex-col justify-between gap-2 overflow-auto">
                <div className="details flex flex-col">
                    <h2 className="font-medium truncate text-sm sm:text-base">{chat.product.apiBook.title}</h2>
                    <p className="text-sm">{Number(chat.product.dbBook.price/100).toFixed(2).toString().replace(/\./g, ',')} kr.</p>
                </div>
                {chat.messages.length > 0 ?
                    <div className="lastMsg text-sm">
                        <p className="truncate"><span className="font-medium">{chat.messages[chat.messages.length-1].sender === user._id ? "Dig" : chat.seller._id !== user._id ? chat.seller.first_name : chat.buyer.first_name}: </span> {chat.messages[chat.messages.length-1].content.replace(/\\n/g, " ")}</p>
                    </div>
                :
                    ""}
            </div>
            {chat.messages.length > 0 && !chat.messages[chat.messages.length-1].seen && chat.messages[chat.messages.length-1].sender !== user._id ?
                <div className="w-4 h-4 absolute bg-emerald-600 rounded-full right-5 z-10"></div>
            :
                ""}
        </div>
    )
}

export default ChatsSingle